'use client';

import { env } from '@skin-seoul/env-utils';
import Script from 'next/script';
import type { ComponentProps } from 'react';
import React from 'react';
import { useCookieConsentStatus } from '@/providers/CookieConsentProvider';
type ExternalScript = ComponentProps<typeof Script>;
const EXTERNAL_SCRIPTS: ExternalScript[] = [{
  id: 'klaviyo-script',
  src: 'https://static.klaviyo.com/onsite/js/TV8ybb/klaviyo.js',
  type: 'text/javascript',
  defer: true
}, {
  id: 'dyn-rev-bundle',
  src: 'https://bundle.dyn-rev.app/loader.js?g_cvt_id=4f3fa35e-10aa-47b1-a0f7-3291f81056c8',
  defer: true
}];
export default function ExternalScripts() {
  const {
    hasAnalyticsConsent,
    hasAdvertisingConsent,
    requiresConsent
  } = useCookieConsentStatus();

  // For EU users, wait for explicit consent before loading analytics/advertising scripts
  const shouldLoadAnalytics = !requiresConsent || hasAnalyticsConsent;
  const shouldLoadAdvertising = !requiresConsent || hasAdvertisingConsent;
  return <>
      {/* Marketing scripts - load only with advertising consent */}
      {shouldLoadAdvertising && EXTERNAL_SCRIPTS.map(script => <Script key={script.id} id={script.id} src={script.src} strategy="lazyOnload" {...script} onLoad={() => {
      /**
       * External Scripts Component
       * @note Klaviyo queue flush: The onLoad callback provides a backup mechanism to flush
       * queued events. Primary flush happens via Object.defineProperty setter in useKlaviyo hook.
       */
      if (script.id === 'klaviyo-script') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const g: any = typeof window !== 'undefined' ? window : undefined;
        if (g && typeof g.__klaviyoFlushQueues === 'function') {
          g.__klaviyoFlushQueues();
        }
      }
    }} />)}
      {/* Analytics scripts - load only with analytics consent */}
      {env('NEXT_PUBLIC_ENV') === 'PROD' && shouldLoadAnalytics && <Script id="hotjar-init" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `
              (function(h,o,t,j,a,r){
                  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                  h._hjSettings={hjid:5060834,hjsv:6};
                  a=o.getElementsByTagName('head')[0];
                  r=o.createElement('script');r.async=1;
                  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                  a.appendChild(r);
              })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `
    }} />}
      {env('NEXT_PUBLIC_ENV') === 'PROD' && shouldLoadAnalytics && <Script id="microsoft-clarity-analytics" strategy="afterInteractive" dangerouslySetInnerHTML={{
      __html: `
              (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/" + i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                // Clarity ID
              })(window, document, "clarity", "script", "sylqsq4u42");
            `
    }} />}
      {shouldLoadAdvertising && <Script id="hs-script-loader" src="//js-na2.hs-scripts.com/243500494.js" type="text/javascript" strategy="lazyOnload" async defer />}
    </>;
}